/**
 * Parallax for the collection / recipe banner (sections/bx-collection-hero.liquid, bx-article-hero.liquid).
 * Only when the photo is clearly taller than the banner: the image is then shown at its own height instead of
 * object-fit: cover and slides up more slowly than the page while the banner scrolls out of view.
 *
 * The movement itself is a CSS scroll-driven animation (animation-timeline: scroll(), see .bx-hero-parallax in
 * src/styles/app.css), so the browser runs it on the compositor. A scroll listener that sets a transform lags a
 * frame behind on iOS and judders. This script only measures, on load and resize: how much photo is hidden
 * (--bx-par-start, from the banner's crop setting) and over how many pixels of scrolling it is shown
 * (--bx-par-range). Browsers without scroll-driven animations keep the plain cropped banner.
 */
const HERO = '.bx-collection-hero';
const MIN_SPARE = 40; // px of photo outside the banner before it is worth moving
const SPEED = 0.35; // image moves this much slower than the page

function measure(hero, img) {
  const ratio = img.naturalWidth && img.naturalHeight ? img.naturalHeight / img.naturalWidth : 0;
  const spare = ratio * hero.clientWidth - hero.clientHeight;
  // object-position "center Y%" → the same share of the spare height above the banner.
  const match = /(\d+(?:\.\d+)?)%\s*$/.exec(img.style.objectPosition || '');
  const focal = match ? parseFloat(match[1]) / 100 : 0.5;
  const start = spare * focal;
  const active = ratio > 0 && spare > MIN_SPARE && start > 1;
  hero.classList.toggle('bx-hero-parallax', active);
  if (!active) return;
  hero.style.setProperty('--bx-par-start', `${start.toFixed(1)}px`);
  hero.style.setProperty('--bx-par-range', `${(start / SPEED).toFixed(0)}px`);
}

export function initHeroParallax() {
  if (!window.CSS || !CSS.supports('animation-timeline: scroll()')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll(HERO).forEach((hero) => {
    const img = hero.querySelector('.bx-collection-hero__media img');
    if (!img) return;
    const run = () => measure(hero, img);
    // The mobile <source> can be a different photo, so measure whatever was actually loaded.
    img.addEventListener('load', run);
    if (img.complete) run();
    if ('ResizeObserver' in window) new ResizeObserver(run).observe(hero);
  });
}
